import { FC, useState, createContext, useContext, useMemo, useCallback } from 'react'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryResponse } from './QueryResponseProvider'

const ListViewContext = createContext<ListViewContextProps>(initialListView)

export const ListViewProvider: FC<WithChildren> = ({ children }) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)

  const { isLoading, response } = useQueryResponse()
  const data = useMemo(() => response?.data || [], [response?.data])
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

  const onSelect = useCallback(
    (id: ID) => {
      groupingOnSelect(id, selected, setSelected)
    },
    [selected]
  )
  const onSelectAll = useCallback(() => {
    groupingOnSelectAll(isAllSelected, setSelected, data)
  }, [isAllSelected, data])
  // Estável: quem a usa num efeito (ex.: limpar seleção ao mudar filtro) não precisa reexecutar
  // a cada render do provider.
  const clearSelected = useCallback(() => {
    setSelected([])
  }, [])

  const value = useMemo(
    () => ({ selected, disabled, isAllSelected, onSelect, onSelectAll, clearSelected }),
    [selected, disabled, isAllSelected, onSelect, onSelectAll, clearSelected]
  )

  return <ListViewContext.Provider value={value}>{children}</ListViewContext.Provider>
}

export const useListView = () => useContext(ListViewContext)
